import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * Capacitor iOS Audio Fix
 * Handles iOS-specific audio issues in Capacitor WebView
 */

// Define the plugin interface
interface AudioPluginInterface {
  unlockAudio(): Promise<{ success: boolean; message: string }>;
}

// Register the custom plugin
const AudioPlugin = registerPlugin<AudioPluginInterface>('AudioPlugin');

export async function initializeCapacitorAudio() {
  // Only run on iOS
  if (Capacitor.getPlatform() !== 'ios') {
    return;
  }
  
  try {
    // Call native plugin if available
    const result = await AudioPlugin.unlockAudio();
  } catch (error) {
    // Fallback: JavaScript-based unlock
    unlockIOSAudioFallback();
  }
}

function unlockIOSAudioFallback() {
  // Create audio context
  const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
  if (!AudioContext) return;
  
  const context = new AudioContext();
  
  // Create empty buffer
  const buffer = context.createBuffer(1, 1, 22050);
  const source = context.createBufferSource();
  source.buffer = buffer;
  source.connect(context.destination);
  
  // Play silent sound
  source.start(0);
  
  // Resume context if suspended
  if (context.state === 'suspended') {
    context.resume();
  }
  
}

// Auto-initialize on first user interaction
if (Capacitor.getPlatform() === 'ios') {
  let initialized = false;
  
  const initOnInteraction = () => {
    if (!initialized) {
      initialized = true;
      initializeCapacitorAudio();
    }
  };
  
  document.addEventListener('touchstart', initOnInteraction, { once: true });
  document.addEventListener('click', initOnInteraction, { once: true });
}